<template>
	<tr>
		<td>
			<v-checkbox v-model="verfügbar" :disabled="true" hide-details></v-checkbox>
		</td>
		<td class="text-xs-left">
			<strong>{{ item.blexonBeschreibung }}<br /></strong>
			<span style="font-size: 12px" v-for="(price, index) in item.prices" :key="index">
				{{ price.item1 == 0 ? "Standard" : "Lange Lieferzeit" }}:
				{{ price.item2 | formatDigit }} {{ item.currency }}<br />
			</span>
		</td>
		<td class="text-xs-right">{{ item.thickness | formatDigit }}</td>
		<td class="text-xs-right">
			<v-text-field
				v-model="item.fertigerName"
				placeholder="Fertigerbezeichnung"
				hint="Technische Bezeichnung Boost"
				title="Muss genau dem Namen des Materials in Boost / Fab des Fertigers entsprechen. Wird dieses Feld leer gelassen, werden keine Aufträge mit diesem Material an den Fertiger zugewiesen."
				@change="
					() => {
						item.fertigerName = item.fertigerName.trim();
						updateMaterial(item);
					}
				"
			></v-text-field>
			<v-text-field
				v-model="item.fertigerBeschreibung"
				placeholder="Beschreibung"
				hint="Name auf Dokumenten"
				@change="
					() => {
						item.fertigerBeschreibung = item.fertigerBeschreibung.trim();
						updateMaterial(item);
					}
				"
			></v-text-field>
		</td>
		<td>
			<v-text-field
				v-model="item.beschaffungszeit"
				type="number"
				:disabled="!showDeliveryTimes"
				style="max-width: 50px"
				@change="updateMaterial(item)"
			></v-text-field>
		</td>
		<td>
			<v-text-field
				v-model="item.kleinsterLochdurchmesser"
				type="number"
				style="max-width: 50px"
				@change="updateMaterial(item)"
			></v-text-field>
		</td>
		<td>
			<v-text-field
				v-model="item.maximaleTeileLaenge"
				type="number"
				placeholder="Länge"
				hint="Länge"
				style="width: 80px"
				@change="updateMaterial(item)"
			></v-text-field>
			<v-text-field
				v-model="item.maximaleTeileBreite"
				type="number"
				placeholder="Breite"
				hint="Breite"
				style="width: 80px"
				@change="updateMaterial(item)"
			></v-text-field>
		</td>
		<td>
			<v-checkbox
				v-model="item.isWeldingAvailable"
				@change="updateMaterial(item)"
				hide-details
			></v-checkbox>
		</td>
		<td>
			<v-layout column>
				<v-flex v-if="item.isHotDipZincCoatingEnabled != null">
					<v-checkbox
						v-model="item.isHotDipZincCoatingEnabled"
						hide-details
						label="Feuerverzinken"
						@change="updateMaterial(item)"
					>
					</v-checkbox>
				</v-flex>
				<v-flex v-if="item.isGalvanizeZincCoatingEnabled != null">
					<v-checkbox
						v-model="item.isGalvanizeZincCoatingEnabled"
						hide-details
						label="Galvanisch"
						@change="updateMaterial(item)"
					>
					</v-checkbox>
				</v-flex>
			</v-layout>
		</td>
		<td>
			<v-checkbox
				v-model="threeDotOneCertificate"
				@change="updateMaterial(item)"
				hide-details
				label="3.1"
			>
			</v-checkbox>
		</td>
	</tr>
</template>

<script>
export default {
	props: {
		item: {},
		showDeliveryTimes: Boolean,
	},
	data() {
		return {};
	},
	created() {},
	computed: {
		verfügbar: {
			// getter
			get: function () {
				return this.item.fertigerName !== "" && this.item.fertigerName !== null;
			},
		},
		threeDotOneCertificate: {
			// getter
			// Bei mehreren Zertifikaten muss das bitweise gemacht werden.
			get: function () {
				return this.item.certificateTypes === 2;
			},
			set: function (value) {
				this.item.certificateTypes = value ? 2 : 0;
			},
		},
	},
	methods: {
		updateMaterial(material) {
			this.$emit("update", material);
		},
	},
};
</script>

<style>
.theme--light.v-input--selection-controls.v-input--is-disabled .v-icon {
	color: #efbb20 !important;
}
</style>
